import $ from 'jquery';
import InView from 'inview';
import imagesLoaded from 'imagesloaded';
import lightGallery from 'lightgallery';
import slick from 'slick-carousel';
import {scroll} from './_commons/scroll.js';
import {forms} from './_commons/forms.js';
import {effects} from './_commons/effects.js';
import {layout } from './_commons/layout.js';
import {cookies} from './_commons/cookies.js';
import { modalMenu } from './_commons/modal-menu.js';
import {modules} from './_commons/modules.js';


layout($, InView,lightGallery);
scroll($);
forms($);
modalMenu($);
effects($, TweenLite, imagesLoaded);
modules($, slick, TweenLite);
cookies($);
